/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import { Host, Optional, forwardRef, Inject } from '@angular/core';
import classNames from 'classnames';

import { Menu } from './menu';
/**
 * Menu导航菜单
 * 参考: https://github.com/react-component/menu
 */
export class MenuItemGroup {
    isMenuItemGroup = true;

    disabled = true;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} parentMenu
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private parentMenu: Menu) {

    }
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.parentMenu && this.parentMenu.prefixCls || '';
    }
/**
 * 最终样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames({
            [`${this.prefixCls}-item-group`]: 1
        }, this.class);
        return classes;
    }
/**
 * @return {?}
 */
get titleClass(): string {
        return `${this.prefixCls}-item-group-title`;
    }
/**
 * @return {?}
 */
get listClass(): string {
        return `${this.prefixCls}-item-group-list`;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-menu-item-group',
    template: `
        <div [class]="titleClass">
            <ng-content select="[ant-menu-group-title]"></ng-content>
        </div>
        <div [class]="listClass">
            <ng-content></ng-content>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Menu, decorators: [{ type: Inject, args: [forwardRef(() => Menu), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function MenuItemGroup_tsickle_Closure_declarations() {
/** @type {?} */
MenuItemGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MenuItemGroup.ctorParameters;
/** @type {?} */
MenuItemGroup.propDecorators;
/** @type {?} */
MenuItemGroup.prototype.isMenuItemGroup;
/** @type {?} */
MenuItemGroup.prototype.disabled;
/**
 * 用户CSS样式
 * @type {?}
 */
MenuItemGroup.prototype.class;
/** @type {?} */
MenuItemGroup.prototype.renderer;
/** @type {?} */
MenuItemGroup.prototype.elementRef;
/** @type {?} */
MenuItemGroup.prototype.parentMenu;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
